import UsageStatService from 'business/services/UsageStatService';

const usageStatService: UsageStatService = new UsageStatService();

export const exportUsageStatCSV = async (timeSpan: number) => {
  const res = await usageStatService.exportUsageStatCSV(timeSpan);
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement('a');
  link.href = url;
  const date = new Date();
  link.setAttribute(
    'download',
    'RockMaker_UsageStats' +
      '_' +
      date.getFullYear() +
      '_' +
      (date.getMonth() + 1) +
      '_' +
      date.getDate() +
      '_' +
      date.getHours() +
      '_' +
      date.getMinutes() +
      '_' +
      date.getSeconds() +
      '.csv',
  );
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const usageStatLogger = async (feature: string) => {
  await usageStatService.usageStatLogger(feature);
};
